import { useQuery } from '@tanstack/react-query';
import {
  registrationQueries,
  type RegistrationsListParams
} from '@/features/registration';
import {
  receptionQueries,
  type ShipmentsListParams
} from '@/features/reception';

interface UseQrNavigateSearchOptions {
  searchInput: string;
  stage: string;
  enabled: boolean;
}

interface NavigateSearchResult {
  id: number;
  display: string;
}

interface UseQrNavigateSearchResult {
  results: NavigateSearchResult[];
  isFetching: boolean;
}

export function useQrNavigateSearch({
  searchInput,
  stage,
  enabled
}: UseQrNavigateSearchOptions): UseQrNavigateSearchResult {
  const isReception = stage === 'reception';

  const searchParams: RegistrationsListParams = {
    search: searchInput,
    current_stage: stage,
    per_page: 1
  };

  const receptionSearchParams: ShipmentsListParams = {
    search: searchInput,
    per_page: 1
  };

  const { data: regData, isFetching: regFetching } = useQuery({
    ...registrationQueries.list(searchParams),
    enabled: enabled && !isReception
  });

  const { data: recData, isFetching: recFetching } = useQuery({
    ...receptionQueries.list(receptionSearchParams),
    enabled: enabled && isReception
  });

  const isFetching = isReception ? recFetching : regFetching;

  const results: NavigateSearchResult[] = isReception
    ? (
        (recData?.data ?? []) as Array<{ id: number; shipment_number: string }>
      ).map((s) => ({ id: s.id, display: s.shipment_number }))
    : (
        (regData?.data ?? []) as Array<{ id: number; container_number: string }>
      ).map((r) => ({ id: r.id, display: r.container_number }));

  return { results, isFetching };
}
